export const mapShiftGeneratorPayload = (request: any) => {
    return {
        id: request.id,
    };
};
